import React, { Suspense } from 'react';
import lazyWithRetry from 'utils/lazyWithRetry';
import PlatformProtectedRoute from 'components/auth/PlatformProtectedRoute';
import PlatformLayout from 'layouts/PlatformLayout';
import Loader from 'wrapper/loader';

const Dashboard = lazyWithRetry(() => import('pages/platform/Dashboard'));
const CompanyManagement = lazyWithRetry(() => import('pages/platform/CompanyManagement'));
const CompanyInvitations = lazyWithRetry(() => import('pages/platform/CompanyInvitations'));
const Analytics = lazyWithRetry(() => import('pages/platform/Analytics'));
const Settings = lazyWithRetry(() => import('pages/platform/Settings'));
const PlatformLogin = lazyWithRetry(() => import('pages/platform/PlatformLogin'));
const PlatformAuthCallback = lazyWithRetry(() => import('pages/platform/PlatformAuthCallback'));

const PlatformLoader = () => <Loader variant="gray" FullScreen={true} />;

const platformRoutes = [
  // Public platform routes (no auth required)
  {
    path: '/platform/login',
    element: (
      <Suspense fallback={<PlatformLoader />}>
        <PlatformLogin />
      </Suspense>
    ),
  },
  {
    path: '/platform/auth/callback',
    element: (
      <Suspense fallback={<PlatformLoader />}>
        <PlatformAuthCallback />
      </Suspense>
    ),
  },
  // Protected platform routes
  {
    path: '/platform',
    element: <PlatformProtectedRoute />,
    children: [
      {
        element: <PlatformLayout />,
        children: [
          {
            path: 'dashboard',
            element: (
              <Suspense fallback={<PlatformLoader />}>
                <Dashboard />
              </Suspense>
            ),
          },
          {
            path: 'companies',
            element: (
              <Suspense fallback={<PlatformLoader />}>
                <CompanyManagement />
              </Suspense>
            ),
          },
          {
            path: 'invitations',
            element: (
              <Suspense fallback={<PlatformLoader />}>
                <CompanyInvitations />
              </Suspense>
            ),
          },
          {
            path: 'analytics',
            element: (
              <Suspense fallback={<PlatformLoader />}>
                <Analytics />
              </Suspense>
            ),
          },
          {
            path: 'settings',
            element: (
              <Suspense fallback={<PlatformLoader />}>
                <Settings />
              </Suspense>
            ),
          },
        ],
      },
    ],
  },
];

export default platformRoutes;
